/**
 * App Store のバッジ。
 *
 * 画像は **Apple 配布の公式アートワーク（日本語版 SVG）をそのまま**置いている（`public/badges/app-store-ja.svg`。
 * Apple の Marketing Tools から取得）。**改変しない・角丸や枠を足さない・縦横比を変えない**のが
 * Apple の決まりなので、大きさは高さだけで決める。
 *
 * Apple の決まりでは、バッジは App Store のアプリのページへのリンクとして使う。**アプリを公開するまで
 * リンク先が無い**ので、`href` が `null` の間は押せない形で出す（`lib/links.ts` の `APP_STORE_URL`）。
 */
export function AppStoreBadge({ href }: { href: string | null }) {
  const image = (
    <img src="/badges/app-store-ja.svg" alt="App Store からダウンロード" className="h-15 w-auto" />
  );

  if (href === null) {
    // 押せないことは読み上げで伝える。見た目は変えない（公式のアートワークを薄くしたりしない）。
    return (
      <div role="img" aria-label="App Store からダウンロード（まだ公開していません）">
        <div aria-hidden="true">{image}</div>
      </div>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block rounded-sm focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-blue"
    >
      {image}
    </a>
  );
}
